import makeTable from '../../components/makeTable.jsx';

export const UserTable = makeTable([
  ['E-mail', 30],
  ['Sites', 40],
  ['Sign up date', 15],
  ['Last login', 15],
]);
